export const ACTION_PREFIX = 'MAIN';

export const actionTypes = {
  SHOW_MAIN_LOADING: 'SHOW_MAIN_LOADING',
  HIDE_MAIN_LOADING: 'HIDE_MAIN_LOADING',
  SHOW_MAIN_LOADING_AS_SUCCESS: 'SHOW_MAIN_LOADING_AS_SUCCESS',
  RESET_INVITATION_CODE: 'RESET_INVITATION_CODE',
  SET_INVITATION_CODE: 'SET_INVITATION_CODE',
  RESET_INVITER_ROLE: 'RESET_INVITER_ROLE',
  SET_INVITER_ROLE: 'SET_INVITER_ROLE',
  SET_PORTAL: 'SET_PORTAL',
  GET_STARTUP_CONFIG_PENDING: 'GET_STARTUP_CONFIG_PENDING',
  GET_STARTUP_CONFIG_FULFILLED: 'GET_STARTUP_CONFIG_FULFILLED',
  GET_STARTUP_CONFIG_REJECTED: 'GET_STARTUP_CONFIG_REJECTED',
  SET_INVITED_STATUS: 'SET_INVITED_STATUS',
  SET_BROKER_INVITED_STATUS: 'SET_BROKER_INVITED_STATUS',
  SET_JOURNEY_ACCOUNT_TYPE: 'SET_JOURNEY_ACCOUNT_TYPE',
};
